// header Design
$(window).on('load scroll resize', function(){
	if ($(window).scrollTop() == 0) {
        // $('.border-img').hide();
        $('#shopify-section-header').css('background-color','rgba(255,255,255,0)');
        $('#shopify-section-header header').css('background-color','rgba(255,255,255,0)');
        $('#shopify-section-header nav').css('background-color','rgba(255,255,255,0)');
      } else {
        // $('.border-img').show();
        $('#shopify-section-header').css('background-color','rgba(255,255,255,0.5)');
        $('#shopify-section-header header').css('background-color','rgba(255,255,255,0.5)');
        $('#shopify-section-header nav').css('background-color','rgba(255,255,255,0.5)');
      }
});